import { render, staticRenderFns } from "./TotalUSCovidDeaths.vue?vue&type=template&id=45df76e1&"
import script from "./TotalUSCovidDeaths.vue?vue&type=script&lang=js&"
export * from "./TotalUSCovidDeaths.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports